<a
  class="notification-link"
  (click)="navigate()"
  [innerHTML]="
    (payloadData?.comparisonEnabled
      ? 'Analysis::StatisticComparison:Result:Comparison:ReadyNotification'
      : 'Analysis::StatisticComparison:Result:Analysis:ReadyNotification'
    ) | abpLocalization
  "></a>
